<template>
  <div
    class="row_edit_frame mb_row_edit_frame"
    :style="{
    left:$store.state.row.mb_edit.left + 'px',
    top:$store.state.row.mb_edit.top + 'px',
  }"
    @mouseenter="edit_show"
    @mouseleave="edit_hidden"
    v-if="$store.state.row.mb_edit.isShow && $store.state.row.mb_edit.select_row.name_ !== 'layout_row__basic_footnav'"
  >
    <div class="row_edit">
      <p @click="edit_row">{{$t('widgets_basic_footnav_edit_567')}}</p>
      <template v-if="$store.state.row.mb_edit.select_row && $store.state.row.mb_edit.select_row.data.is_system != 'true' && $store.state.row.mb_edit.select_row.name != 'mobile_header'">
        <el-tooltip class="item" effect="light" :content="$t('components_my_mb_edit_index_2366')" placement="top">
          <div class="set el-icon-view add mb_hidden" @click="hidden_row"></div>
        </el-tooltip>
      </template>
    </div>
  </div>
</template>

<script>
import i18n from '../../language/index'

export default {
  name: "my_mb_edit",
  methods: {
    edit_row() {
      const select_row = this.$store.state.row.mb_edit.select_row;
      if (select_row) {
        this.$store.commit("app/SET_module_Data", select_row);
        this.$store.commit("main_dialog/Change_main_dialog_isShow", true);
        this.$store.commit("main_dialog/Change_edit_name", select_row.name);
      }
    },
    hidden_row() {
      const select_row = this.$store.state.row.mb_edit.select_row;
      if (!this.$store.state.mb_row_isShow.row_btn_isShow) {
        this.row_animation();
      } else {
        select_row.data.mb_infor.isShow = false;
      }
    },

    //隐藏动画
    row_animation() {
      const select_row = this.$store.state.row.mb_edit.select_row;
      const id = select_row.widgets_id;
      const rowType = select_row.rowType;
      const t = $("#u" + id).offset().top;
      const l = $(window).width() / 2 - 375 / 2;
      const h = $("#u" + id).height();
      const dom = $('<div class="row_animation_frame"></div>');
      const btn_t = $(".jz_mobi_btn_showAllRow").offset().top;
      const btn_l = $(".jz_mobi_btn_showAllRow").offset().left;
      this.$store.commit("row/Reset_mb_edit");

      dom.appendTo("#app_child_frame");
      dom.css({
        top: t,
        left: l,
        height: h
      });
      $("#u" + id).addClass("row_hidden");
      const timer = setTimeout(() => {
        $(".row_animation_frame").css({
          top: btn_t + 5,
          left: btn_l + 5,
          width: 30,
          height: 30
        });
        clearTimeout(timer);
      }, 50);
      $(".row_animation_frame")[0].addEventListener(
        "transitionend",
        () => {
          this.animationEnd(id, rowType);
        },
        false
      );

      $(".row_animation_frame")[0].addEventListener(
        "webkitAnimationEnd",
        () => {
          this.animationEnd(id, rowType);
        },
        false
      );
    },

    animationEnd(id, rowType) {
      $(".row_animation_frame").remove();
      const obj = this.templet.find_obj(id, [rowType]).target;
      if (obj) {
        obj.data.mb_infor.isShow = false;
      }

      //判断眼睛按钮显示
      if (!this.$store.state.mb_row_isShow.eye_btn_isShow) {
        this.$store.commit("mb_row_isShow/SET_eye_btn_isShow", true);
      }
      this.templet.mb_eye_isShow();

      //row上面设置透明度的class去除
      this.$nextTick(() => {
        $("#u" + id).removeClass("row_hidden");
      });
    },

    edit_show() {
      //清除关闭的定时器,放置编辑弹框被关闭
      const timer = this.$store.state.row.mb_edit.timer;
      if (timer) {
        clearTimeout(timer);
        this.$store.state.row.mb_edit.timer = null;
      }
    },
    edit_hidden() {
      this.$store.commit("row/Reset_mb_edit");
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/my_mb_edit/index.vue